import { render } from "./Footer.vue?vue&type=template&id=e802b802"
const script = {}

import exportComponent from "C:\\Users\\Kos\\Downloads\\filemgr.mREaF3.2026-05-15_16_14_46\\vxadoor.pro\\hubuntu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__